import { render, staticRenderFns } from "./modal-saved-addresses.vue?vue&type=template&id=7447fb8d&scoped=true&lang=pug"
import script from "./modal-saved-addresses.js?vue&type=script&lang=js&external"
export * from "./modal-saved-addresses.js?vue&type=script&lang=js&external"
import style0 from "./modal-saved-addresses.vue?vue&type=style&index=0&id=7447fb8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447fb8d",
  null
  
)

export default component.exports